import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ButtonFile } from '../../../components';
import LoadingComponent from '../../../components/Loading';
import * as CONST from '../../../constants/FieldsConst';
import { validFielddHelper } from '../../../helpers/ValidFieldsHelper';
import { useNotification } from '../../../helpers/notification';
import { saveApiKeysAction } from '../../../store/Actions';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';

const acceptOnlyImages = 'image/png, image/jpeg, image/jpg';
const ApiKeysForm = () => {
  const dispatch = Redux.useDispatch();
  const { addNotification } = useNotification();

  const [fileImage, setFileImage] = React.useState(null);

  const apiKeysStore = Redux.useSelector((state) => state.apiKeys);
  const activo = apiKeysStore.activo;

  const dataDefault = {
    [CONST.NAME]: '',
    [CONST.ACTIVE]: true,
  };
  const [apiKey, setApiKey] = React.useState(dataDefault);
  const [dataError, setDataRequired] = React.useState({
    [CONST.NAME]: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    setFileImage(null);
    if (!activo) {
      setApiKey(dataDefault);
      return;
    }
    let data = {};
    Object.keys(apiKey).map((key) => (data[key] = apiKeysStore.activo[key]));
    setTimeout(() => setApiKey(data), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setApiKey({ ...apiKey, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).forEach((key) => {
      const val = apiKey[key];
      const valid = val === null || val === '' || val === 0;
      r[key] = valid;
      va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    const valid = _validDataForm();
    if (valid) {
      setLoadingSave(true);
      const data = { ...apiKey };
      await saveApiKeysAction({ dispatch, addNotification }, activo?.id, data);
      setApiKey(dataDefault);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form" sx={{ m: 2 }}>
      {/*       
      <pre>
            {JSON.stringify(banco, null, 2)}
          </pre> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingComponent
            isLoading={loadingSave}
            text={activo ? 'Actualizando...' : 'Guardando...'}
          />
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Generar API KEY
          </Typography>
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <TextField
            fullWidth
            size="small"
            id={CONST.NAME}
            required
            label="Nombre"
            value={apiKey.name}
            onChange={(e) => _handleSetDataField(CONST.NAME, e.target.value)}
            helperText={dataError.name ? validFielddHelper(1) : null}
            error={dataError.name}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth>
            <InputLabel id={`label-${CONST.ACTIVE}`}>Estatus</InputLabel>
            <Select
              labelId={`label-${CONST.ACTIVE}`}
              size="small"
              value={apiKey.active}
              label="Estatus"
              onChange={(e) =>
                _handleSetDataField(CONST.ACTIVE, e.target.value)
              }
              id={CONST.ACTIVE}
            >
              <MenuItem value={true}>Activo</MenuItem>
              <MenuItem value={false}>Bloqueado</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={12} sx={{ m: 2 }} align="center">
          <BotonNuevoComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            morado
            mr={2}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApiKeysForm;
